import { formatDateLocaleLima } from '../../../../utils/dateUtils';

export const FILTER_STORAGE_KEY = 'compras.priceTracking.filters.v2';

export const defaultDateTo = () => new Date().toISOString().slice(0, 10);

export const defaultDateFrom = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 11);
  d.setDate(1);
  return d.toISOString().slice(0, 10);
};

export const defaultFilters = () => ({
  dateFrom: defaultDateFrom(),
  dateTo: defaultDateTo(),
  supplierId: '',
  productId: '',
  currency: '',
  insumosOnly: false,
  spikeThreshold: 10,
  search: '',
});

export const loadStoredFilters = () => {
  try {
    const raw = sessionStorage.getItem(FILTER_STORAGE_KEY);
    if (!raw) return defaultFilters();
    return { ...defaultFilters(), ...JSON.parse(raw) };
  } catch {
    return defaultFilters();
  }
};

export const saveStoredFilters = (filters) => {
  try {
    sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));
  } catch {
    /* ignore */
  }
};

export const formatMoney = (n, currency = 'PEN') => {
  const symbol = currency === 'USD' ? 'US$' : 'S/';
  return `${symbol} ${(parseFloat(n) || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatPrice = (n) => (parseFloat(n) || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 4 });

export const formatPct = (n) => {
  if (n == null || n === '') return '—';
  return `${n > 0 ? '+' : ''}${Number(n).toFixed(1)}%`;
};

export const buildFilterParams = (filters, options = {}) => {
  const params = {
    date_from: filters.dateFrom,
    date_to: filters.dateTo,
    spike_threshold: filters.spikeThreshold,
    insumos_only: options.allPurchasedItems ? 0 : (filters.insumosOnly ? 1 : 0),
  };
  if (options.allPurchasedItems) {
    params.products_limit = 0;
  }
  if (filters.supplierId) params.supplier_id = filters.supplierId;
  if (filters.productId) params.product_id = filters.productId;
  if (filters.currency) params.currency = filters.currency;
  if (filters.search?.trim()) params.search = filters.search.trim();
  return params;
};

export const purchaseLineKey = (row) => `${row.item_type || 'product'}:${row.item_id ?? row.product_id}`;

export const canOpenPurchaseProductDetail = (row) => (
  (row?.item_type || 'product') === 'product' && Boolean(row?.product_id ?? row?.item_id)
);

export const REPORT_PAGES = [
  { id: 'dashboard', label: 'Dashboard', path: '/compras/reports/price-tracking', icon: '📊' },
  { id: 'alerts', label: 'Alertas de precio', path: '/compras/reports/price-tracking/alerts', icon: '⚠️' },
  { id: 'suppliers', label: 'Proveedores', path: '/compras/reports/price-tracking/suppliers', icon: '🏢' },
  { id: 'products', label: 'Por producto', path: '/compras/reports/price-tracking/products', icon: '📦' },
  { id: 'history', label: 'Historial', path: '/compras/reports/price-tracking/history', icon: '📋' },
];

export { formatDateLocaleLima };
